<template>
  <div style="overflow: hidden" class="fill-height fill-wdith">
    <v-toolbar
      dark
      prominent
      class="main-toolbar"
      >
        <v-app-bar-nav-icon  @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>Background Gaming</v-toolbar-title>
        
        <div class="nav-links hidden-sm-and-down">
          <div 
            v-for="link in mainNavLinks" 
            :key="link.route"
            class="nav-link"
            :class="{ active: $route.path === link.route, disabled: link.disabled }"
            @click="!link.disabled && $router.push(link.route)"
          >
            {{ link.name }}
            <span v-if="link.disabled" class="coming-soon">coming soon</span>
          </div>
        </div>
        
        <v-spacer></v-spacer>
      <!-- <login></login> -->
        <v-toolbar-items class="hidden-sm-and-down">
          <!-- <v-btn flat>Link One</v-btn>
          <v-btn flat>Link Two</v-btn> -->
          <Notification></Notification>
        </v-toolbar-items>
      </v-toolbar>
      <v-layout class="main-content fill-width">
       <v-navigation-drawer
         v-model="drawer"
         location="left"
         temporary>
        <v-list-item
          v-if="user"
          :prepend-avatar="avatar"
          :title="user"
          class="drawer-user"
        ></v-list-item>
        <v-divider v-if="user"></v-divider>
        <v-list nav>
          <v-list-item
            v-for="link in mainNavLinks"
            :key="link.route"
            :title="link.name"
            :disabled="link.disabled"
            :active="$route.path === link.route"
            active-color="warning"
            @click="!link.disabled && ($router.push(link.route), drawer = false)"
          ></v-list-item>
          <v-divider class="my-2"></v-divider>
          <v-list-item
            v-if="user"
            title="Logout"
            @click="$router.push('/logout'); drawer = false"
          ></v-list-item>
        </v-list>
      </v-navigation-drawer>
      <router-view/>
      <footer class="site-footer">
        <router-link to="/privacy">Privacy Policy</router-link>
        <span class="footer-sep">·</span>
        <span>© {{ new Date().getFullYear() }} Background Gaming Media LLC</span>
      </footer>
    </v-layout>
  </div>
</template>
<script>
import {userService} from './services/user.service';
import Notification from './components/Notification.vue';
export default {
  mounted: function() {
    this.userSub2 = userService.getCurrentUser().subscribe((user) => {
      this.user = user?.username;
      this.avatar = user?.profileImageLink;
    });
    this.userSub = userService.getUserRoutes().subscribe((routes) => {
      this.navItems = routes;
    });
    console.log('mounted');
  },
  unmounted() {
    if(this.userSub) {
      this.userSub.unsubscribe();
      this.userSub = null;
    }
     if(this.userSub2) {
      this.userSub2.unsubscribe();
      this.userSub2 = null;
    }
  },
  components: {
    Notification,
  },
  data() {
    return { 
      notifications: [],
      drawer: false,
      user: '',
      avatar: 'https://static-cdn.jtvnw.net/jtv_user_pictures/zealenth-profile_image-f705bb2ecd1e7bec-70x70.png',
      navItems: [
        'foo',
        'bar',
        'baz'
      ],
      mainNavLinks: [
        { name: 'Home', route: '/' },
        { name: 'BGG FGC', route: '/bgg_fgc' },
        { name: 'Games', route: '/games' },
        { name: 'B-Roll Request', route: '/broll-request' },
        { name: 'Game Guesser', route: '/game_guesser' },
        { name: 'Our Team', route: '/team' }
      ]
    }
  } 
    
}
</script>

<style>
/* =============================================
   BASE
   ============================================= */
html { overflow: hidden !important }

html, body, #app, #app > div {
  height: 100%;
}

body {
  background-color: #080c14;
  background-image: radial-gradient(rgba(0, 229, 255, 0.03) 1px, transparent 1px);
  background-size: 28px 28px;
  font-family: 'Rajdhani', sans-serif !important;
  font-size: 1.05rem;
}

/* =============================================
   TYPOGRAPHY
   ============================================= */
h1, h2, h3, h4, h5, h6,
.v-card-title {
  font-family: 'Rajdhani', sans-serif !important;
  letter-spacing: 0.05em !important;
}

/* Monospace for numbers/stats */
.prize-amount,
.summary-value,
.score-cell,
.score-display,
.donation-amount,
.current-total {
  font-family: 'Share Tech Mono', monospace !important;
}

/* =============================================
   TOOLBAR
   ============================================= */
@keyframes toolbar-shift {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.main-toolbar {
  background: linear-gradient(90deg,
    #060e1e 0%,
    #0a1830 25%,
    #071428 50%,
    #0a1830 75%,
    #060e1e 100%
  ) !important;
  background-size: 300% 100% !important;
  animation: toolbar-shift 10s ease infinite !important;
  border-bottom: 1px solid rgba(0, 229, 255, 0.35) !important;
  box-shadow: 0 2px 24px rgba(0, 229, 255, 0.12) !important;
}

.main-content {
  height: calc(100% - 64px);
  overflow-y: auto;
}

.site-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 6px 24px;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.3);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(6, 10, 20, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  z-index: 10;
}

.footer-sep {
  opacity: 0.4;
}

/* =============================================
   NAV LINKS
   ============================================= */
.nav-links {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 40px;
  height: 100%;
}

.nav-link {
  position: relative;
  padding: 8px 20px;
  font-family: 'Rajdhani', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.75);
  cursor: pointer;
  transition: color 0.2s ease, text-shadow 0.2s ease;
  text-transform: uppercase;
}

.nav-link:hover {
  color: #00e5ff;
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.5);
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 10%;
  width: 80%;
  height: 2px;
  background: #00e5ff;
  transform: scaleX(0);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  border-radius: 2px;
}

.nav-link:hover::after {
  transform: scaleX(0.6);
  box-shadow: 0 0 8px rgba(0, 229, 255, 0.7);
}

.nav-link.active {
  color: #ff9800;
  text-shadow: 0 0 10px rgba(255, 152, 0, 0.4);
}

.nav-link.active::after {
  transform: scaleX(1);
  background: #ff9800;
  box-shadow: 0 0 10px rgba(255, 152, 0, 0.6);
}

.nav-link.disabled {
  color: rgba(255, 255, 255, 0.3);
  cursor: not-allowed;
}

.nav-link.disabled:hover {
  color: rgba(255, 255, 255, 0.3);
  text-shadow: none;
}

.nav-link.disabled::after {
  display: none;
}

.coming-soon {
  position: absolute;
  bottom: -14px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.65rem;
  color: #ff9800;
  text-transform: lowercase;
  opacity: 0;
  transition: opacity 0.2s ease;
  white-space: nowrap;
}

.nav-link.disabled:hover .coming-soon {
  opacity: 1;
}

/* =============================================
   CARDS — glassmorphism + entrance animation
   ============================================= */
@keyframes card-enter {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

.v-card {
  background: rgba(10, 18, 34, 0.72) !important;
  backdrop-filter: blur(14px) !important;
  -webkit-backdrop-filter: blur(14px) !important;
  border: 1px solid rgba(0, 229, 255, 0.1) !important;
  border-radius: 12px !important;
  animation: card-enter 0.3s ease-out both;
  transition: border-color 0.3s ease, box-shadow 0.3s ease !important;
}

.v-card:hover {
  border-color: rgba(0, 229, 255, 0.22) !important;
  box-shadow: 0 0 24px rgba(0, 229, 255, 0.06) !important;
}

/* =============================================
   BUTTONS — glow on hover
   ============================================= */
.v-btn:not(.v-btn--icon) {
  font-family: 'Rajdhani', sans-serif !important;
  font-weight: 600 !important;
  letter-spacing: 0.07em !important;
  transition: box-shadow 0.25s ease, transform 0.15s ease !important;
}

.v-btn:not(.v-btn--icon):hover {
  box-shadow: 0 0 14px rgba(255, 152, 0, 0.45) !important;
  transform: translateY(-1px);
}

.v-btn[color="primary"]:not(.v-btn--icon):hover {
  box-shadow: 0 0 14px rgba(0, 229, 255, 0.45) !important;
}

.v-btn[color="error"]:not(.v-btn--icon):hover {
  box-shadow: 0 0 14px rgba(239, 68, 68, 0.45) !important;
}

/* =============================================
   LINKS
   ============================================= */
* a,
*:link,
*:any-link,
.v-list-item a,
.v-navigation-drawer a,
.v-list a,
router-link,
.router-link,
a[href] {
  color: #ff9800 !important;
  text-decoration: none !important;
}

* a:hover,
*:link:hover,
.v-list-item a:hover,
.v-navigation-drawer a:hover,
.v-list a:hover,
router-link:hover,
.router-link:hover,
a[href]:hover {
  color: #00e5ff !important;
  text-decoration: underline !important;
}

* a:visited,
*:visited,
.v-list-item a:visited,
.v-navigation-drawer a:visited,
.v-list a:visited,
router-link:visited,
.router-link:visited,
a[href]:visited {
  color: #03dac6 !important;
}

.router-link-active,
.v-list-item .router-link-active {
  color: #4caf50 !important;
  font-weight: bold !important;
}

/* =============================================
   ARTICLE BODY TEXT
   ============================================= */
.faded p,
.faded li,
.faded blockquote {
  font-size: 1.05rem !important;
  line-height: 1.75 !important;
  color: rgba(255, 255, 255, 0.82) !important;
}

.faded h1, .faded h2, .faded h3 {
  font-family: 'Rajdhani', sans-serif !important;
  letter-spacing: 0.04em !important;
  color: rgba(255, 255, 255, 0.95) !important;
}

/* =============================================
   SECTION LABELS (uppercase + spacing)
   ============================================= */
.v-card-title {
  text-transform: uppercase;
  letter-spacing: 0.08em !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
</style>